import {Modal, cookieHelper} from '@shopify/marketing-assets';

ShopifyMarketing.StickyBannerModal = (function() {
  const Cookie = cookieHelper;

  function StickyBannerModal(template, options) {
    this.templateElement = template;
    this.options = options || {};

    // Empty trigger
    this.trigger = [];
    this.cookie = 'announcement_closed_sticky-banner-create-shop';

    this.body = document.body;
    this.activeClass = 'js-sticky-banner-modal-active';

    const signUpTrigger = document.querySelector('.js-open-signup');
    if (signUpTrigger) {
      // eslint-disable-next-line @shopify/prefer-early-return
      document.body.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-open-signup')) {
          document.querySelector('.js-modal-open').classList.remove('js-sticky-banner-modal-active');
          document.querySelector('.js-is-active').classList.remove('js-sticky-banner-modal-open');
          document.querySelector('#CloseIcon').classList.remove('icon-modules-close-black');
          window.ShopifyMarketing.signup.SignupModal.open();
        }
      });

      document.body.addEventListener('click', (evt) => {
        if (evt.target.id === 'CloseIcon') {
          window.ShopifyMarketing.signup.SignupModal.close();
        }
      });
    }

    Modal.call(this, this.trigger, this.template.bind(this), {
      clickingOverlayClosesModal: false,
      modalStyleModifierClasses: {
        closeIcon: 'icon-modules-close-black',
        container: 'modal-container--lowlight',
      },
      ...this.options,
    });
  }

  StickyBannerModal.prototype = Object.create(Modal.prototype);

  StickyBannerModal.prototype.open = function(...args) {
    if (this.clientHasViewedAnnouncement()) { return; }

    this.body.classList.add(this.activeClass);
    const container = this.modalDom.$container;
    container.classList.add('js-sticky-banner-modal-open');

    Modal.prototype.open.apply(this, args);
    container.getElementsByClassName('sticky-modal')[0].classList.remove('visibility-hidden');
  };

  StickyBannerModal.prototype.close = function() {
    Modal.prototype.close.call(this, () => {
      this.body.classList.remove(this.activeClass);
    });

    this.setClientHasViewedCookie();
  };

  StickyBannerModal.prototype.template = function() {
    const node = this.templateElement.cloneNode(true);
    return node.outerHTML;
  };

  StickyBannerModal.prototype.clientHasViewedAnnouncement = function() {
    return Boolean(Cookie.get(this.cookie));
  };

  StickyBannerModal.prototype.setClientHasViewedCookie = function() {
    Cookie.set(this.cookie, true);
  };

  return StickyBannerModal;
})();
